import React, { PureComponent } from "react";
import PricingChart from "./charts/pricing";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";

class Pricing extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  }

  get sellingPriceAuto() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: this.getDataValue(team_id, "Average Selling Price - Auto")
      });
    });

    return data;
  }

  get sellingPriceMobile() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: this.getDataValue(team_id, "Average Selling Price - Mobile")
      });
    });

    return data;
  }

  render() {
    return (
      <div className="col-md-3 col-xs-12">
        <div className="bg-white p-30 mh-858">
          <h5>
            PRICING
            <HelpIconButtonWithTooltipAndTypeformModal
              iconSize="sm"
              {...TypeformContent.PRICING}
            />
          </h5>
          <hr />
          <div className="mt-30">
            <PricingChart
              title="MOBILE PHONES"
              id="chartHorizontalBarPricingPhones"
              data={this.sellingPriceMobile}
            />
          </div>
          <div className="mt-30">
            <PricingChart
              title="AUTONOMOUS VEHICLES"
              id="chartHorizontalBarPricingVehicles"
              data={this.sellingPriceAuto}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/pricing.js